import { createRouter, createWebHistory } from 'vue-router';
import { defineAsyncComponent } from 'vue'

const SafeAsync = (loader) =>
    defineAsyncComponent({
        loader,
        delay: 200,
        timeout: 10000,
        errorComponent: {
            template: '<div>Error loading component</div>',
        },
        loadingComponent: {
            template: '<div>Loading...</div>',
        },
    });

const routes = [

    {
        path: '/',
        name: 'homePage',
        component: SafeAsync(() => import('../components/HomePage/homePage.vue'))
    },


    {
        path: '/login',
        name: 'loginPage',
        component: SafeAsync(() => import('../components/Login/loginPage.vue'))
    },
    {
        path: '/signup',
        name: 'signupPage',
        component: SafeAsync(() => import('../components/SignUp/signUp.vue'))
    },
    {
        path: '/forgetpassword',
        name: 'forgetPassword',
        component: SafeAsync(() => import('../components/ForgetPassword/forgetPassword.vue'))
    },

    {
        path: '/EmailConfirmed',
        name: 'emailConfirmed',
        component: SafeAsync(() => import('../components/User/EmailConfirmed.vue'))
    },
    {
        path: '/ResetPassword',
        name: 'resetPassword',
        component: SafeAsync(() => import('../components/ResetPassword/ResetPassword.vue'))
    },


    {
        path: '/successPage',
        name: 'successPage',
        meta: { requiresAuth: true },
        component: SafeAsync(() => import('../components/Pages/successPage.vue')),
    },
    {
        path: '/dashboard',
        name: 'dashBoard',
        meta: { requiresAuth: true },
        component: SafeAsync(() => import('../components/Patient/patientDashboard.vue')),
        children: [
            {
                path: '/patientDashboardView',
                name: 'patientDashboardView',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/Patient/patientDashboardView.vue')),
            },
            {
                path: '/patientCheckout',
                name: 'patientCheckout',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/Patient/patientCheckout.vue')),
            },
            {
                path: '/patientBooking',
                name: 'patientBooking',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/Patient/patientBooking.vue')),
            },
            {
                path: '/patientFavourites',
                name: 'patientFavourites',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/Patient/patientFavourites.vue')),
            },
            {
                path: '/searchdoctor',
                name: 'searchDoctor',
                component: SafeAsync(() => import('../components/SearchDoctor/searchDoctor.vue'))
            },
            {
                path: '/timeLines',
                name: 'timeLines',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/Patient/timeLines.vue')),
            },
            {
                path: '/patientMedicalRecords',
                name: 'patientMedicalRecords',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/Patient/patientMedicalRecords.vue')),
            },
            {
                path: '/departmentList',
                name: 'departmentList',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/Departments/DepartmentList.vue')),
            },
            {
                path: '/reportsList',
                name: 'reportsList',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/Reports/reportsList.vue')),
            },
            {
                path: '/allReports',
                name: 'allReports',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/Patient/allReports.vue')),
            },
            {
                path: '/doctorProfile',
                name: 'doctorProfile',
                component: SafeAsync(() => import('../components/DoctorProfile/doctorProfile.vue'))
            },
            {
                path: '/uploadReports',
                name: 'uploadReports',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/UploadReports/uploadReports.vue')),
            },
            {
                path: '/addUploadReports',
                name: 'addUploadReports',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/UploadReports/addUploadReports.vue')),
            },

            {
                path: '/patientProfile',
                name: 'patientProfile',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/Patient/patientProfile.vue')),
            },
            {
                path: '/changePassword',
                name: 'changePassword',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/Patient/patientChangePassword.vue')),
            },
            {
                path: '/doctorProfileSetting',
                name: 'doctorProfileSetting',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/DoctorProfile/doctorProfileSetting.vue')),
            },
            {
                path: '/doctorDashboard',
                name: 'doctorDashboard',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/DoctorProfile/doctorDashboard.vue')),
            },
            {
                path: '/slots',
                name: 'slotsPage',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/DoctorProfile/slotsPage.vue')),
            },
            {
                path: '/doctorsociallinks',
                name: 'doctorSocialLinks',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/DoctorProfile/doctorSocialLinks.vue')),
            },
            {
                path: '/patientFamily',
                name: 'patientFamily',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/Patient/patientFamily.vue')),
            },
            {
                path: '/addPatientFamily',
                name: 'addPatientFamily',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/Patient/addPatientFamily.vue')),
            },
            {
                path: '/doctorChangePassword',
                name: 'doctorChangePassword',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/DoctorProfile/doctorChangePassword.vue')),
            },
            {
                path: '/doctorAppointment',
                name: 'doctorAppointment',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/DoctorProfile/doctorAppointment.vue')),
            },
            {
                path: '/doctorPatient',
                name: 'doctorPatient',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/DoctorProfile/doctorPatient.vue')),
            },
            {
                path: '/zoomMeetings',
                name: 'zoomMeetings',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/zoom/zoomMeeting.vue')),
            },
            {
                path: '/patientProfiles',
                name: 'patientProfiles',
                meta: { requiresAuth: true },
                component: SafeAsync(() => import('../components/DoctorProfile/patientProfiles.vue')),
            },
            {
                path: '/appointmentDetails',
                name: 'appointmentDetails',
                meta: { requiresAuth: true },
                component: () => import('../components/DoctorProfile/appointmentDetails.vue'),
            },
            {
                path: '/reviews',
                name: 'doctorRatings',
                meta: { requiresAuth: true },
                component: () => import('../components/DoctorProfile/doctorRatings.vue'),
            },
        ]
    }
];

const router = createRouter({
    mode: 'history',
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router